module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp1_0.2a209861.png";